<template>
  <div class="update-covid-test">
    <div class="introduce">
      <h1 class="header">Kết quả xét nghiệm COVID-19</h1>
      <p>
        Vui lòng xem hướng dẫn chụp ảnh kết quả xét nghiệm và đảm bảo ảnh được chụp theo đúng yêu cầu dưới đây hoặc xem chi tiết tại đây
        <a href="https://ahamove.com/huongdanxetnghiemtainha/">Xem hướng dẫn</a>
      </p>
      <div class="tutorial">
          <img v-if="isMobile" :src="`/img/covid-test/M-Instruct-test.png`" width="325" alt="ahamove-covid-test" />

          <img v-else :src="`/img/covid-test/D-Instruct-test.png`" alt="ahamove-covid-test" />
        
      </div>
      <div class="action">
        <button class="btn-update" @click="createNewTest">Cập nhật kết quả xét nghiệm</button>
      </div>
    </div>
    <div class="list-covid-test">
      <h1 class="header">Lịch sử xét nghiệm COVID-19</h1>
      <div class="empty" v-if="test_covid_19_info.length === 0">
          <img :src="`/img/covid-test/empty.png`" width="200" alt="ahamove-covid-test" />
          <h3>Chưa cập nhật</h3>
          <p>Kết quả xét nghiệm sẽ được hiển thị tại đây sau khi bạn cập nhật thành công</p>
      </div>
      <div class="covid-test-item" v-for="(item, index) in test_covid_19_info" :key="index" @click="viewTest(item)">
        <div class="covid-test-item__info" >
          <p class="datetime">{{format_date(item.tested_at)}}</p>
          <h6 class="reason">{{item.reason ==='urgent_test' ? 'Mẫu khẩn cấp' : 
            item.reason ==='routine_test' ? 'Mẫu thường quy': 'Xét nghiệm di chuyển'}}</h6>
          <p class="result-type">{{item.result_type === 'e_certificate' ? 'Phiếu chứng nhận kết quả xét nghiệm điện tử hoặc QR' :
            item.result_type === 'certitficate' ? 'Giấy chứng nhận kết quả xét nghiệm (bản cứng)': 
            'Mẫu xét nghiệm tự test nhanh'}}</p>
        </div>
        <div class="covid-test-item__result">
          <img :src="`/img/covid-test/${item.result === 'negative' ? 'negative': 'positive'}.png`" alt="ahamove-covid-test" width="70" height="70"/>
        </div>
      </div>
    </div>
    <Toast ref="toastRef" :icon="'Success'" :message="'Cập nhật kết quả xét nghiệm thành công'"/>

  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import moment from "moment";
import Toast from "@/components/Toast";

export default {
  name: "CovidTest",
  components:{
    Toast
  },
  data(){
    return{
      
    }
  },
  computed: {
    ...mapState({
      test_covid_19_info: state => state.covidTest.test_covid_19_info,
      create_success: state => state.covidTest.create_success
    }),
    ...mapGetters(["supplierToken"]),  
    isMobile() {
      return screen.width < 500
    }
  },
  methods:{
    getListCovidTest(){
      this.$store.dispatch('getListCovidTest', {token: this.supplierToken})
    },
    createNewTest(){
      this.$store.dispatch('getItemCovidTest', {
        name: "",
        reason: "test_for_move",
        result: "negative",
        result_type: "e_certificate",
        result_url: "",
        supplier_id: "",
        test_technique: "rapid_test",
        test_type: "pool",
        tested_at: null,
      })

      this.$router.push({name : 'covid-test-form', params : {id : 'create'},query: { token: this.supplierToken}})
    },
    viewTest(item){
      this.$store.dispatch('getItemCovidTest', item)
      this.$router.push({name : 'covid-test-form', params : {id : item._id},query: { token: this.supplierToken}})
    },
    format_date(value){
      if (value) {
        return moment(value*1000).format('DD/MM/YYYY')
      }
    },
  },
  mounted(){
    this.getListCovidTest()
    if(this.create_success){
        if(this.$refs.toastRef){
          this.$refs.toastRef.show = true
        }
      }
  },
};
</script>

<style lang="scss" scoped>
h1.header {
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  color: #1a1a1a;
  margin-bottom: 10px;
}
.update-covid-test {
  background-color: #e5e5e5;
  height: 100vh;
  overflow-y: auto;
  .introduce {
    background-color: #ffffff;
    padding: 16px;
    margin-bottom: 12px;
    max-width: 700px;
    margin: 0 auto;
    p {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      color: #7a8189;
    }
    span {
      color: #ff8200;
    }
  }
  .form {
    background-color: #ffffff;
  }
  .action {
    margin-top: 16px;
    .btn-update {
      background: #ff8200;
      border: 0;
      border-radius: 2px;
      height: 48px;
      margin: 0 auto;
      color: #fff;
      text-transform: none;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
.tutorial{
  margin: 16px 0;
  display: flex;
  justify-content: space-between;
  &-certitficate{
    margin-right: 10px;
  }
  &-header{
    background-color: #ff8200;
    color: #ffffff;
    font-size: 30px;
    font-weight: 500;
    text-align: center;
    flex-basis: 1;
  }
}
.list-covid-test{
  background-color: #ffffff;
  padding: 16px;
  max-width: 700px;
  margin: 0 auto;
  margin-top: 10px;
  .empty{
    margin: 40px auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    h3 {
      color: #7A8189;
      font-size: 16px;
      line-height: 22px;
      font-weight: 500;
    }
    p{
      color: #878D96;
      text-align: center;
    }
  }
}
.covid-test-item{
  border: 1px solid #E5E7E8;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 12px;
  margin-bottom: 16px;
  &__info{
    cursor: pointer;
    .datetime{
      font-size: 14px;
      font-weight: 400;
      line-height: 16px;
      color: #7A8189;
    }
    .reason{
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      color: #0F1011;
    }
    .result-type{
      font-size: 14px;
      font-weight: 400;
      line-height: 16px;
      color: #0F1011;
    }
  }
  &__result{
    img{
      width: 70px;
      height: 70px;
      max-width: inherit ;
    }
  }
}
@media screen and (max-width: 500px) {
  .tutorial{
    flex-direction: column;
    img{
      width: 100%;
      margin-bottom: 16px;
    }
  }
  // .covid-test-item__result{
  //   max-width: 50px;
  // }
}
</style>
